import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { queryKeys } from '@/lib/api/queryKeys';
import type { AvailableGame, GameDef } from '@/lib/api/types';

/**
 * El catálogo de juegos.
 *
 * Vive en el módulo `game` de la plataforma (`g_game`), no en Xotski ni en
 * Xurvey: es transversal, como los eventos o las estaciones. Aquí sólo se lee.
 *
 * `available` no es el catálogo entero — aplica el plan de la empresa y las
 * concesiones de `co_company_game`, y marca cada juego con `entitled`. Quien
 * ofrezca juegos debe ofrecer sólo los contratados: enseñar los demás para que
 * al pulsarlos no pase nada es peor que no enseñarlos.
 */
export const gamesApi = {
  listCatalog: () => api.get<GameDef[]>('/g-game'),
  listAvailable: () => api.get<AvailableGame[]>('/g-game/available'),
};

export function useAvailableGames() {
  return useQuery({
    queryKey: queryKeys.games.available,
    queryFn: () => gamesApi.listAvailable(),
    // Un plan no cambia mientras alguien elige un juego.
    staleTime: 5 * 60_000,
  });
}
